// libs
import React from "react";
import Icon from "@ant-design/icons";

const WorkShiftSvg = () => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8 5.68421V2.84211H11.2V5.68421H16.8ZM2.8 9.94737V22.7368C2.8 23.5184 3.43 24.1579 4.2 24.1579H23.8C24.57 24.1579 25.2 23.5184 25.2 22.7368V9.94737C25.2 9.16579 24.57 8.52632 23.8 8.52632H4.2C3.43 8.52632 2.8 9.16579 2.8 9.94737ZM25.2 5.68421C26.754 5.68421 28 6.94895 28 8.52632V24.1579C28 25.7353 26.754 27 25.2 27H2.8C1.246 27 0 25.7353 0 24.1579L0.014 8.52632C0.014 6.94895 1.246 5.68421 2.8 5.68421H8.4V2.84211C8.4 1.26474 9.646 0 11.2 0H16.8C18.354 0 19.6 1.26474 19.6 2.84211V5.68421H25.2Z"
      fill="#4867AA"
    />
  </svg>
);

const WorkShiftIcon = (props) => <Icon component={WorkShiftSvg} {...props} />;

export default WorkShiftIcon;
